import { structureImportWorkflow } from "@Api/Workflows/structureImport";
export async function insertImage({ id, token }) {
    if (id === null) {
        throw new Error("ID cannot be null");
    }
    const res = await structureImportWorkflow(token, id);
    if (res.data.length === 0) {
        throw new Error("The structure rendered no images");
    }
    await Word.run(async (context)=>{
        const controls = context.document.contentControls;
        context.load(controls, "tag");
        await context.sync();
        const prefix = `sync-image-${id}-`;
        const synced = controls.items.filter((cc)=>cc.tag.startsWith(prefix));
        let anchor = synced.length ? synced[synced.length - 1].getRange(Word.RangeLocation.whole) : undefined;
        res.data.forEach((image, index)=>{
            const existing = synced.find((cc)=>cc.tag === `${prefix}${index}`);
            if (existing) {
                existing.insertInlinePictureFromBase64(image, Word.InsertLocation.replace);
                return;
            }
            const imageRange = anchor ? anchor.insertInlinePictureFromBase64(image, Word.InsertLocation.after) : context.document.body.insertInlinePictureFromBase64(image, Word.InsertLocation.end);
            const contentControl = imageRange.insertContentControl();
            contentControl.title = `image-${index}`;
            contentControl.tag = `${prefix}${index}`;
            anchor = contentControl.getRange(Word.RangeLocation.whole);
        });
        synced.filter((cc)=>Number(cc.tag.slice(prefix.length)) >= res.data.length).forEach((cc)=>cc.delete(false));
        await context.sync();
    });
}
